// extracted by mini-css-extract-plugin
export default {"mainWrapper":"carrier-info_mainWrapper__n3DSj","boxWrapper":"carrier-info_boxWrapper__ba1qC","rowWrapper":"carrier-info_rowWrapper__X2cvf"};